import { provideHttpClient, HttpHeaders, withXhr } from '@angular/common/http';
import { EnvironmentProviders, inject, Provider } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { SetContextLink } from '@apollo/client/link/context';
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '../environments/environment';

const GRAPH_URL = environment.graph;
const SPACES_CLIENT = '693adac8a2b7f6ab89412d0d';

const withDefaults = new SetContextLink((_prevContext) => {
  // if (heap) {
  //   sessionId = heap.getSessionId();
  // }
  const sessionId = '';
  const headers = new HttpHeaders()
    .set('spaces_client', SPACES_CLIENT)
    .set('spaces_session', sessionId);
  return { headers };
});

function createApollo(httpLink: HttpLink): ApolloClient.Options {
  const http = httpLink.create({
    uri: GRAPH_URL,
    withCredentials: true,
  });

  // Login app only performs authentication flows; session refresh/retry is handled by the
  // consuming apps (e.g. mission-control-web) and by cookie-session behavior end-to-end.
  const link = ApolloLink.from([withDefaults, http]);

  return {
    cache: new InMemoryCache({}),
    link: link,
  };
}

export function provideGraphQL(): Array<Provider | EnvironmentProviders> {
  return [
    provideHttpClient(withXhr()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      return createApollo(httpLink);
    }),
  ];
}
